import common from '../../../public/static/locales/en/common.json';

export default {
  defaultLanguage: 'en',
  lng: 'en',
  fallbackLng: 'en',
  otherLanguages: [],
  detection: {
    cookieOptions: {
      secure: true,
      sameSite: 'Strict',
    },
  },
  resources: {
    en: {
      common,
    },
  },
};
